import { render, staticRenderFns } from "./Xkz.vue?vue&type=template&id=944b09e0&scoped=true&"
import script from "./Xkz.vue?vue&type=script&lang=js&"
export * from "./Xkz.vue?vue&type=script&lang=js&"
import style0 from "./Xkz.vue?vue&type=style&index=0&id=944b09e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944b09e0",
  null
  
)

export default component.exports